Vue.filter('span', function (value) {
    value = value + '';
    return value.replace(/(\w)/g, '<span>$&</span>');
});
